import { ENDPOINT, METHOD } from '@/constants';
import { DTO } from '../base/dto';

export class EncryptionDTO extends DTO {
  public param: undefined;
  public url = ENDPOINT.Encryption;
  public method = METHOD.GET;
  body: undefined;
  public query: undefined;
  public headers: undefined;
  constructor() {
    super();
  }
}
